function resetShareForm() {
    $('#shareModal').on('shown.bs.modal', function() {
        grecaptcha.reset(shareCaptcha);
        $('#ShareRecaptchaResponse').val('');
        $('#shareModal .messageCaptchaFailed').addClass('hide');
        $('#agreeToTermsError').addClass('hide');
        $('#frmShare #Message').val('Hi!\nI found this at www.bayleys.co.nz.\nPlease check it out and let me know your thoughts!');
    });
}

function shareListingForm() {
    if ($('#watchSharePrint').length > 0 && $('#share, #share-email').length > 0) {

        resetShareForm();

        $('#frmShare .listing-button').click(function (e) {
            if (!$('#frmShare #AgreeToTerms').is(':checked')) {
                e.preventDefault();
                $('#agreeToTermsError').removeClass('hide');
                return $('#frmShare').valid();
            }

            if ($('#ShareRecaptchaResponse').val().length === 0) {
                e.preventDefault();
                $('#shareCaptchaError').show();
                return $('#frmShare').valid();
            }
            // $('#frmShare .listing-button').attr('disabled', 'disabled');
        });

        $('#frmShare').submit(function (e) {
            if ($(this).valid()) {
                var data = $(this).serialize();
                var uri = '/share-api/submit';
                if ($(this).hasClass('watch-list-share')) {
                    var listingIds = [];
                    var listings = $('.listing');
                    for (var i = 0; i < listings.length; i++) {
                        listingIds.push($(listings[i]).data('listingid'));
                    }
                    data += '&ListingIds=' + listingIds.join(',');
                    uri = '/share-api/share-watch-list';
                }
                $.post(uri, data)
                  .success(function (data) {
                      if (data.ShareId !== 0) {
                        $('#shareModal').modal('hide');
                        swal({
                            title: 'Listing shared',
                            text: 'Thank you! This has been shared.',        
                            confirmButtonText: 'Ok',
                            confirmButtonClass: 'btn-info btn-outline',
                            type: 'success',
                            timer: 15000,
                            html: true
                        });
                      } else if (!data.RecaptchaValid) {
                          $('#shareFormFields').hide();
                          $('#shareModal .messageCaptchaFailed').removeClass('hide');
                      }
                  });
                e.preventDefault();
                return false;
            }
        });

        $('#frmShare #AgreeToTerms').click(function () {
            if ($('#frmShare #AgreeToTerms').is(':checked')) {
                $('#agreeToTermsError').hide();
            } else {
                $('#agreeToTermsError').show();
            }
        });

    }
}